import { useContext } from "react";
import ProductCard from "../components/ProductCard";
import { VscClose } from "react-icons/vsc";
import useScrollWindow from "../../../../hooks/scrollWindow";
import productsContext from "../../../../dataManager/context/productsContext";
import LoaderCard from "../../../utils/loadersBox/LoaderCard";
import searchContext from "../../../../dataManager/context/searchContext";
import categoriesContext from "../../../../dataManager/context/categoriesContext";
import PlaceholderNoFilterProduct from "./components/PlaceholderNoFilterProduct";
import InputRange from "../../../elements/form/InputRange";
import { MAX_PRISE } from "../../../../datas/constantsValues";
import Paragraph from "../../../elements/p/Paragraph";
import Input from "../../../../components/elements/form/Input";

const AllProducts = ({ classe }) => {
  //value while scrolling the banner is going hidden
  const SCROLL_MAX_Y = 500;

  //context variables
  const { products } = useContext(productsContext);
  const { categories } = useContext(categoriesContext);
  const { priceRange, keyword, filters, setPriceRange, addKeyword } =
    useContext(searchContext);

  // get the current scroll value
  const [scrollPositionY] = useScrollWindow();

  /**
   * filter all the products base on the search value
   * @param {Array} products
   * @param {String} searchValue
   * @returns array of products filtered
   */
  const filterBySeach = (products, searchValue = "") => {
    const productsFielterBySearch = products.filter((product) => {
      // i
      if (searchValue === "") return true;

      //extract where to search
      const { name, description, caracteristics } = product;

      //search in the product name
      const searchInName = name
        .toLowerCase()
        .includes(searchValue.toLocaleLowerCase());

      //search in the product caracteristics
      const searchInCaracteristics = caracteristics
        .toLowerCase()
        .includes(searchValue.toLocaleLowerCase());

      //search in the product description
      const searchInDescription = description
        .toLowerCase()
        .includes(searchValue.toLocaleLowerCase());

      return searchInName || searchInDescription || searchInCaracteristics;
    });

    return productsFielterBySearch;
  };

  /**
   * Filter all the products base on the category tags
   * @param {Array} products
   * @param {Array} tags
   * @returns Array of products filtered by tags
   */
  const filterByTags = (products, tags = []) => {
    const productsFielterByTags = products.filter((product) => {
      if (!tags.length) return true;

      const productToCheck = product.getCategoryMembership.toLowerCase();

      return tags.includes(productToCheck);
    });

    return productsFielterByTags;
  };

  const filterByPrise = (products, priseToFilter) => {
    const productFilteredByPrise = products.filter(
      (product) => +product.getPrise <= +priseToFilter
    );

    return productFilteredByPrise;
  };

  // loading cards
  const allLoaderCards = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
    (arg, index) => <LoaderCard classe="w-auto md:w-56" key={index} />
  );

  //product fieltered by prise
  const productFilteredByPrise = filterByPrise(products, priceRange);
  const productFilteredBySearch = filterBySeach(
    productFilteredByPrise,
    keyword
  );
  const productFiltered = filterByTags(productFilteredBySearch, filters);

  // all filtered products by tags, by search, and by prise
  const allProductsBox = productFiltered?.map((product) => (
    <ProductCard product={product} />
  ));

  const formatNumber = (num) => (num < 10 ? `0${num}` : num);

  return (
    <section className={`${classe} mainContentProducts relative`}>
      <div
        className={`${
          scrollPositionY > SCROLL_MAX_Y
            ? "top-[78px] md:top-[103px]"
            : "top-[78px] md:top-[141px]"
        } bg-wite min-h-20 sticky z-50  min-h-[50px] rounded bg-white px-1 pb-[7px] pt-0.5 shadow-md md:px-2 md:pb-3 ${
          ![...filters].length && "hidden"
        }`}
      >
        <h3 className="font-nunito text-base font-semibold text-secondary">
          Catégories des produts cherchés
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center space-x-4 space-y-1 lg:mt-3 lg:space-x-5">
          {[...filters]?.map((filter, index) => (
            <Badge title={filter} key={index} />
          ))}
        </div>
      </div>

      <div className="mt-32 flex  flex-col justify-center md:mt-0">
        <div className=" flex flex-wrap items-center justify-center space-x-2 space-y-2 md:hidden">
          {categories.map((c) => (
            <FilterBox classe category={c}>
              {c.getName}
            </FilterBox>
          ))}
        </div>

        <div className="mt-3">
          <InputRange
            labelName={`Prix (${priceRange}) fcfa`}
            min={5000}
            step={200}
            value={priceRange}
            max={MAX_PRISE}
            onChange={setPriceRange}
          />
        </div>
      </div>

      <div className="mt-10 md:mt-32">
        <div className="w-full rounded bg-smoot p-2">
          <h3 className="font-nunito text-sm font-semibold text-secondary ">
            {filterBySeach(products, keyword)?.length
              ? `(${formatNumber(
                  filterBySeach(productFiltered, keyword)?.length
                )})`
              : "(00)"}{" "}
            Articles trouvés
          </h3>
        </div>
        <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
          {products.length > 0 ? allProductsBox : allLoaderCards}
          {products.length > 0 && allProductsBox.length === 0 && (
            <PlaceholderNoFilterProduct />
          )}
        </div>
      </div>
    </section>
  );
};

function Badge({ title, classe }) {
  //context variables
  const { removeFilters } = useContext(searchContext);

  return (
    <div
      className={`${classe} borber flex items-center  space-x-1 rounded-full border-secondary-light bg-smoot px-3 py-1 text-secondary/50 shadow-sm shadow-secondary/30`}
    >
      <span className="inline-block font-nunito text-xs ">{title}</span>
      <VscClose
        size={17}
        className="animate cursor-pointer hover:text-primary"
        onClick={() => {
          console.log(title);
          removeFilters(title);
        }}
      />
    </div>
  );
}

const FilterBox = ({ category }) => {
  //context variables
  const { addFilters } = useContext(searchContext);

  return (
    <div className="flex cursor-pointer justify-center  ">
      <Paragraph
        size="small"
        onClick={() => addFilters(category.getName)}
        classe="px-3 py-1 rounded-full border border-secondary-light text-secondary-light animate hover:border-primary hover:text-primary"
      >
        {category.getName}
      </Paragraph>
    </div>
  );
};

export default AllProducts;
